import {connect} from 'react-redux';

import {makeMapStateToProps, wrapInShallowSelector} from '../../../../srcCommon/helpers/reselectHelpers';
import {getUserTeams} from '../../../store/data/teams/teamsSelectors';
import {ContactNoteComposer} from './contactNoteComposer';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  teams: wrapInShallowSelector(getUserTeams),
}));

export const ContactNoteComposerContainer = connect(mapStateToProps)(ContactNoteComposer);
